import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { PageShell } from "@/components/page-shell";
import { ProfileForm } from "@/components/task-forms/profile-form";
import { ensureConsumerQueryData, profileQueryOptions } from "@/lib/data";
import { requireSession } from "@/lib/session";

export const Route = createFileRoute("/profile_/contact")({
  component: ContactEditPage,
  beforeLoad: requireSession,
  loader: () => ensureConsumerQueryData(profileQueryOptions),
});

function ContactEditPage() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageHeader
        title="Edit contact information"
        description="The name and email the dealer uses to reach you."
        backTo="/profile"
        backLabel="Back to profile"
      />
      <ProfileForm
        sections={["contact"]}
        required={["email"]}
        submitLabel="Save changes"
        onComplete={async () => {
          await navigate({ to: "/profile" });
        }}
      />
    </PageShell>
  );
}
